import { isDev } from '../util';

export const getDevLang = () => (isDev() ? 'zh' : import.meta.env.VITE_APP_LANG);

export const getDevToken = () =>
  `Bearer eyJhbGciOiJIUzUxMiJ9.eyJjcmVhdGVkVGltZSI6MTc0NDI3NzU0MDEyNywiY2xpZW50IjoiQ3JlZml0IiwibGlua1R5cGUiOiIiLCJ1c2VySWQiOiIxNTAyNzQ4In0.L1R6LlsCKAQr3ia-nuAC7lCbHtVKfwZ5fpUU4iUhFWdca5OgV4ubO7gyMNzo1rwkB2jUOAniiY8j9DGTeqQTyg`;

export const getDevIsUIv2 = () =>
  isDev() ? true : import.meta.env.VITE_APP_NEW_VERSION === 'true';
